import endPoints from './endPoints';
import axios from '../../../services/axios';
import { AUTH_REQUEST_TIMEOUT_MS } from './authErrors';

// Sign-in, recovery and sign-out give up after 20 s instead of loading forever.
const authConfig = { timeout: AUTH_REQUEST_TIMEOUT_MS };

const {
	signIn,
	verification,
	resendVerification,
	forgotPassword,
	passwordVerification,
	passwordResendVerification,
	passwordReset,
	signOut
} = endPoints;

/**
 *
 * @description Execute endpoint login
 * @param data
 * @method post
 * @return jsonResponse
 *
 */
export const setLogIn = async (data) => (
	await axios.post(signIn, data, authConfig)
);

/**
 *
 * @description Execute endpoint verification
 * @param id
 * @method get
 * @return jsonResponse
 *
 */
export const getVerification = async (id) => (
	await axios.get(`${verification}${id}`)
);

/**
 *
 * @description Execute endpoint resend verification
 * @param id
 * @method get
 * @return jsonResponse
 *
 */
export const setResendVerification = async (id) => (
	await axios.get(`${resendVerification}${id}`)
);

/**
 *
 * @description Execute endpoint forgot password
 * @param data
 * @method post
 * @return jsonResponse
 *
 */
export const setForgotPassword = async (data) => (
	await axios.post(forgotPassword, data, authConfig)
);

/**
 *
 * @description Execute endpoint forgot password verification
 * @param id
 * @method get
 * @return jsonResponse
 *
 */
export const getPasswordVerification = async (id) => (
	await axios.get(`${passwordVerification}${id}`, authConfig)
);

/**
 *
 * @description Execute endpoint forgot password resend verification
 * @param id
 * @method get
 * @return jsonResponse
 *
 */
export const setPasswordResendVerification = async (id) => (
	await axios.get(`${passwordResendVerification}${id}`, authConfig)
);

/**
 *
 * @description Execute endpoint password reset
 * @param id
 * @param data
 * @method put
 * @return jsonResponse
 *
 */
export const setPasswordReset = async (id, data) => (
	await axios.put(`${passwordReset}${id}`, data, authConfig)
);

/**
 *
 * @description Execute endpoint logout
 * @method get
 * @return jsonResponse
 *
 */
export const setLogOut = async () => (
	await axios.get(signOut, authConfig)
);
